import { render } from "./Separator.vue?vue&type=template&id=3d9c2bff&scoped=true"
import script from "./Separator.vue?vue&type=script&lang=js"
export * from "./Separator.vue?vue&type=script&lang=js"

import "./Separator.vue?vue&type=style&index=0&id=3d9c2bff&scoped=true&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9c2bff"]])

export default __exports__